export const DSN_PAGE_TESTID_PREFIX = 'dsn-page';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const dsnPageTestId = (...parts: Array<string | number | null | undefined>): string =>
  [DSN_PAGE_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const dsnPageRowTestId = (
  base: string,
  identity: string | number | null | undefined
): string | undefined => (testIdSlug(identity) ? dsnPageTestId(base, identity) : undefined);
